// Minimum required user fields
interface MinimalUser {
  id: string;
}

// Base structure with generic user type
interface BaseItem<U extends MinimalUser> {
  id: string;
  user: U;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const replaceListOwnUserName = <T extends BaseItem<any>>(
  list: T[],
  userId: string
): T[] =>
  list.map((item) => {
    if (item.user.id === userId) {
      return {
        ...item,
        user: {
          ...item.user,
          name: 'You'
        }
      } as T;
    }
    return item as T;
  });
